import { __assign, __decorate, __extends } from "tslib";
import { observer } from 'mobx-react';
import * as React from 'react';
import { Suspense } from 'react';
import { injectIntl } from 'react-intl';
import { CSSTransition } from 'react-transition-group';
import PinPad from '../Controllers/Auth/PinPad';
import Core from '../Core';
import CordovaUtils from '../Core/Cordova';
import Messages from '../Core/Messages';
import UserManager from '../Core/UserManager';
import StoreBuilder from '../Stores/Core/StoreBuilder';
import { ElectronToolbar } from './Builder/ElectronToolbar';
var Public = React.lazy(function () { return import('./Builder/Public'); });
var SignedIn = React.lazy(function () { return import('./Builder/SignedIn'); });
var BuilderComponent = /** @class */ (function (_super) {
    __extends(BuilderComponent, _super);
    /**
     * Class constructor
     * @param {IBuilderProps} props Component props
     * @returns {void}
     */
    function BuilderComponent(props) {
        var _this = _super.call(this, props) || this;
        /**Determines which layout to show */
        _this.IsPublic = StoreBuilder.IsPublicRoute || (!Core.IsNative && !UserManager.IsSignedIn) || (Core.IsNative && !UserManager.HasRefreshToken);
        //Althoug setting a core property here IS JUST STUPID, so far I don't have a better solution!
        Messages.Initialize(_this.props.intl);
        return _this;
    }
    /**Render user unauthorized (not signed in) components */
    BuilderComponent.prototype.RenderPublic = function () {
        return (React.createElement(Public, null, this.props.children));
    };
    /**Render user is signed in components */
    BuilderComponent.prototype.RenderSignedIn = function () {
        return (React.createElement(SignedIn, __assign({}, { AppProps: this.props }), this.props.children));
    };
    /**Render native app components */
    BuilderComponent.prototype.RenderNative = function () {
        return (React.createElement(React.Fragment, null,
            React.createElement(CSSTransition, { classNames: "fade", timeout: 300, unmountOnExit: true, mountOnEnter: true, in: UserManager.AppLocked, out: !UserManager.AppLocked },
                React.createElement(PinPad, null)),
            React.createElement(CSSTransition, { classNames: "fade", timeout: 300, unmountOnExit: true, mountOnEnter: true, in: !UserManager.AppLocked, out: !(UserManager.AppLocked && Core.IsNative) }, this.RenderSignedIn())));
    };
    /**
     * Builder component layout
    * @returns {JSX.Element} Component layout
    * */
    BuilderComponent.prototype.render = function () {
        return (React.createElement(Suspense, { fallback: React.createElement(React.Fragment, null) },
            React.createElement("div", { className: "h-100 ".concat(CordovaUtils.IsElectron ? 'electron' : '') },
                CordovaUtils.IsElectron ? React.createElement(ElectronToolbar, null) : React.createElement(React.Fragment, null),
                this.IsPublic ?
                    this.RenderPublic()
                    :
                        Core.IsNative ?
                            this.RenderNative()
                            :
                                this.RenderSignedIn())));
    };
    BuilderComponent = __decorate([
        observer
    ], BuilderComponent);
    return BuilderComponent;
}(React.Component));
export default injectIntl(BuilderComponent);
//# sourceMappingURL=Builder.js.map